export default __webpack_public_path__ + "static/130-76d9acac98ef7b37fac5f910ce67f839.jpg";